import { type FC } from 'react';

import { useSpecContractTerms } from '@/common/hooks/contract';
import {
  type PaidSpecContractType,
  type SpecContractStatusType,
  type SpecContractType,
} from '@/common/types/contract';

import { ContractTerms } from '../../ContractTerms/ContractTerms';

interface GrandContractTermsProps {
  kind: SpecContractType | PaidSpecContractType;
  status: SpecContractStatusType;
}

const GrandContractTerms: FC<GrandContractTermsProps> = ({ kind, status }) => {
  const { data, isOpen, hasContractComplete, hasContractFail, openDate } =
    useSpecContractTerms(kind);

  return (
    data && (
      <ContractTerms
        className="mt-8 mx-[1.625rem]"
        data={data}
        openDate={openDate}
        kind={kind}
        hasContractComplete={hasContractComplete && isOpen}
        hasContractFail={hasContractFail}
        hasContractExpired={status === 'expired'}
      />
    )
  );
};

export { GrandContractTerms };
